<template>

    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
        <z-page title="Senarai : Penyata Pemungut">
            
            <w-form >
              <w-flex class="mt3">
                    <div class="xs4 mr3">
                        <w-select label="Kedah Bayaran" v-model="form.jenis_bayaran" :items="[{label: 'KAUNTER '}]" />
                    </div>
                    <div class="xs4 mr3">
                      <w-input type="date">Tarikh Transaksi</w-input>
                    </div>
                    <div class="xs4">
                      <w-input type="date">Hingga</w-input>
                    </div>
              </w-flex>
            </w-form>

            <div class="mt3 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="$refs.dform.validate()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>

        </z-page>

        <z-page title="Senarai : Penyata Pemungut">

          <w-flex justify-center align-center class="mb2">
            <div class="xs4">
                  <h5 class="fw-semibold">
                      Kedah Bayaran :
                  </h5>
                  <div class="fw-normal my1 fs-1">Semua </div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Tarikh Transaksi :
                  </h5>
                  <div class="fw-normal my1 fs-1">Semua</div>
            </div>
            <div class="xs4">
                  <h5 class="fw-semibold m0">
                      Jumlah Rekod :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 2 </div>
            </div>
          </w-flex>

        <z-table ref="tbluser" title="" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
          <!-- <template #button>
            <w-button 
            dark
            class="indigo-dark2--bg ml1 fs-2" 
            @click="newrecord()"
            >
              <w-icon class="mr1" xs>fal fa-pencil</w-icon> Cipta
            </w-button>
          </template> -->
          
          <template #item-cell.action="{ item, label, header, index }">
            <w-flex class="flex justify-center">
              <inertia-link :href="item.show">
              <w-tooltip top>
                  <template #activator="{ on }">
                    <w-icon v-on="on" >
                      fal fa-pencil
                    </w-icon>
                  </template>
                  Papar
                </w-tooltip>
              </inertia-link>
            </w-flex>
          </template>
      </z-table>
        </z-page>
    </zen-one>

</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: 'bayaran',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/kutipan' },
        { label: 'Penyata Pemungut ', route: '/penyesuaian/penyataan-bank' },
          ],
          form: {
            // id: 0,
            no: '',
            no_dokumen: '',
            },
        }
  },
  methods: {
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>